import { useState, useEffect, useCallback, useContext } from "react";
import Image from 'next/image';
import Link from 'next/link'
import { Popover } from "@douyinfe/semi-ui";
import { useRouter } from "next/router";
import { IndexContext } from "@/stores/index";
import cName from 'classnames';
import styles from "./styles.module.scss";
import { useTranslations } from "next-intl";

type CrumbType = {
  path: string,
  name: string,
  isActive?: boolean,
}

export interface IWrapperProps {
  children: JSX.Element,
  banner?: string,
  bgImage?: string,
  bgColor?: string,
  crumb?: CrumbType[],
  showCrumb?: boolean,
  showPendant?: boolean
}

export default ({ children, banner = 'https://img.cbcechina.com/2026-04-22/e7c5f665458295d9f78d069a0f4dd0a7.png', bgColor = '#ffffff', bgImage = '/image/page-bg.png', crumb = [], showCrumb = true, showPendant = true }: IWrapperProps) => {
  const router = useRouter()
  const t = useTranslations("wrapper");
  const { menuCurrent, menuParent } = useContext(IndexContext);
  const [isHidePendant, setIsHidePendant] = useState(false);

  const toTop = useCallback(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, [])

  return (
    <div className={styles.wrapper} style={{ backgroundColor: bgColor, backgroundImage: `url(${bgImage})` }}>
      {
        banner && (
          <div className={cName(styles.banner)}>
            <div className={styles.cover}>
              <img src={banner} alt="banner" loading='lazy' />
            </div>
          </div>
        )
      }
      {
        showCrumb && (
          <div className={cName(styles.crumb, 'm-1600')}>
            <div className={styles.left}>
              <img className={styles.icon} src="/image/home.png" alt="" />
              <ul className={styles.list}>
                <li className={cName(styles.item)}>
                  <Link href="/">
                    <a target="_self">{router.locale == 'en' ? 'Home' : '首页'}</a>
                  </Link>
                </li>
                {
                  menuParent && (
                    <li className={cName(styles.item)}>
                      <Link href={menuParent?._href || '/'}>
                        <a target={menuParent?._target || '_self'}>{menuParent?._title}</a>
                      </Link>
                    </li>
                  )
                }
                {
                  menuCurrent && (
                    <li className={cName(styles.item, router.pathname === menuCurrent?._href ? styles.active : '')}>
                      <Link href={menuCurrent?._href || '/'}>
                        <a target={menuCurrent?._target || '_self'}>{menuCurrent?._title}</a>
                      </Link>
                    </li>
                  )
                }
                {
                  crumb?.map((item: CrumbType, index: number) => (
                    <li key={index} className={cName(styles.item, item.isActive ? styles.active : '')}>
                      <Link href={item.path} >
                        <a target="_self">{item.name}</a>
                      </Link>
                    </li>
                  ))
                }
              </ul>
            </div>
            <div className={styles.right}>
              <ul className={styles.list}>
                {
                  menuParent?.childlist?.map((item: any) => (
                    <li key={item?.id} className={cName(styles.item, router.pathname === item?._href ? styles.active : '')}>
                      <Link href={item?._href || '/'}>
                        <a target={item?._target || '_self'}>{item?._title}</a>
                      </Link>
                    </li>
                  ))
                }
              </ul>
            </div>
          </div>
        )
      }
      {
        showPendant && (
          <div className={cName(styles.pendant, isHidePendant ? styles.hidden : '')}>
            <ul className={styles.list}>
              <Popover
                showArrow
                style={{
                  backgroundColor: '#F9B000',
                  padding: '15px',
                  width: '230px',
                }}
                content={
                  <div>
                    <img style={{ width: '100%' }} src="/image/help-qrcode.png" alt="" />
                    <p style={{ fontSize: '14px', color: '#ffffff', textAlign: 'center', marginTop: '5px' }}>更多资讯，关注CBCE小助手</p>
                  </div>
                }
                position="left"
              >
                <li>
                  <div className={styles.item}>
                    <img src="/image/wechat.png" alt="" />
                    <span>
                      {
                        t.rich('pendant.item1tit', {
                          br: () => <br />,
                        })
                      }
                    </span>
                  </div>
                </li>
              </Popover>
              <li>
                <Link href="/exhibition/apply" >
                  <a className={styles.item} target="_self">
                    <img src="/image/user1.png" alt="" />
                    <span>
                      {
                        t.rich('pendant.item2tit', {
                          br: () => <br />,
                        })
                      }
                    </span>
                  </a>
                </Link>
              </li>
              <li>
                <Link href={router.locale == "cn" ? "https://cbce2025.expotec-group.com/?member/register&code=sites" : "https://cbce2025.expotec-group.com/?member/register&lang=en"} >
                  <a className={styles.item} target="_blank">
                    <img src="/image/group.png" alt="" />
                    <span>
                      {
                        t.rich('pendant.item3tit', {
                          br: () => <br />,
                        })
                      }
                    </span>
                  </a>
                </Link>
              </li>
              <li>
                <div className={styles.item} onClick={toTop}>
                  <img src="/image/arrow-up.png" alt="" />
                  <span>
                    {
                      t.rich('pendant.item4tit', {
                        br: () => <br />,
                      })
                    }
                  </span>
                </div>
              </li>
            </ul>
            <div className={styles.close} onClick={() => setIsHidePendant(!isHidePendant)}>
              {/* @ts-ignore */}
              <svg t="1723196878237" className="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2672">
                <path d="M320 0 192 128l384 384-384 384 128 128 512-512L320 0z" p-id="2673" fill="#fff">
                </path>
              </svg>
              <span>{t('pendant.hidden')}</span>
            </div>
          </div>
        )
      }
      {children}
    </div>
  )
};
